import apiClient from "../core/HttpClient";
import { Allergy } from "../models";

export default class AllergyService{
    url="/Allergies";
    getAllergy(id:string){
        return apiClient.get(`${this.url}/${id}`);
    }
    getAllergies(){
        return apiClient.get(`${this.url}`);
    }
    createAllergy(allergy:Allergy){
        return apiClient.post(`${this.url}`,allergy);
    }
    updateAllergy(id:number,allergy:Allergy){
        return apiClient.put(`${this.url}/${id}`,allergy);
    }
    deleteAllergy(id:number){
        return apiClient.delete(`${this.url}/${id}`);
    }
    
}